{
  "growth-jira-onboarding.Contact-us": [
    {
      "type": 0,
      "value": "Contact us"
    }
  ],
  "growth-jira-onboarding.footer.atlassian-logo-alt": [
    {
      "type": 0,
      "value": "Atlassian"
    }
  ],
  "growth-jira-onboarding.footer.copyright": [
    {
      "type": 0,
      "value": "Copyright "
    },
    {
      "type": 1,
      "value": "year"
    },
    {
      "type": 0,
      "value": " Atlassian Pty Ltd. All rights reserved. "
    }
  ],
  "growth-jira-onboarding.footer.dot-separator": [
    {
      "type": 0,
      "value": "•"
    }
  ],
  "growth-jira-onboarding.footer.facebook-alt-text": [
    {
      "type": 0,
      "value": "Facebook"
    }
  ],
  "growth-jira-onboarding.footer.facebook-title": [
    {
      "type": 0,
      "value": "Facebook"
    }
  ],
  "growth-jira-onboarding.footer.footer-links.contact-us": [
    {
      "type": 1,
      "value": "contactLink"
    }
  ],
  "growth-jira-onboarding.footer.footer-links.privacy-policy": [
    {
      "type": 1,
      "value": "privacyPolicy"
    }
  ],
  "growth-jira-onboarding.footer.footer-links.read-our-blog": [
    {
      "type": 1,
      "value": "thirdText"
    }
  ],
  "growth-jira-onboarding.footer.linkedin-alt-text": [
    {
      "type": 0,
      "value": "LinkedIn"
    }
  ],
  "growth-jira-onboarding.footer.linkedin-title": [
    {
      "type": 0,
      "value": "LinkedIn"
    }
  ],
  "growth-jira-onboarding.footer.office-address": [
    {
      "type": 0,
      "value": "341 George Street, Sydney, NSW, 2000, Australia"
    }
  ],
  "growth-jira-onboarding.footer.privacy-policy": [
    {
      "type": 0,
      "value": "Privacy Policy"
    }
  ],
  "growth-jira-onboarding.footer.read-our-blog": [
    {
      "type": 0,
      "value": "Read our blog"
    }
  ],
  "growth-jira-onboarding.footer.x-alt-text": [
    {
      "type": 0,
      "value": "X"
    }
  ],
  "growth-jira-onboarding.footer.x-title": [
    {
      "type": 0,
      "value": "X"
    }
  ],
  "growth-jira-onboarding.footer.youtube-alt-text": [
    {
      "type": 0,
      "value": "Youtube"
    }
  ],
  "growth-jira-onboarding.footer.youtube-title": [
    {
      "type": 0,
      "value": "Youtube"
    }
  ],
  "growth-jira-onboarding.invite-reminder-with-board-activity.customer-logos.alt": [
    {
      "type": 0,
      "value": "Customer logos including Twilio, NASA, Illumina, Docker, and Morningstar"
    }
  ],
  "growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.board-heading": [
    {
      "type": 0,
      "value": "Join in on your team’s recent work"
    }
  ],
  "growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.board-heading-text": [
    {
      "type": 0,
      "value": "Here’s what everyone’s been up to in Jira:"
    }
  ],
  "growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.button-text": [
    {
      "type": 0,
      "value": "Start collaborating"
    }
  ],
  "growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.button-text.join-now": [
    {
      "type": 0,
      "value": "Join now"
    }
  ],
  "growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.button-view-all": [
    {
      "type": 0,
      "value": "View all work"
    }
  ],
  "growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.column.assignee": [
    {
      "type": 0,
      "value": "Assignee"
    }
  ],
  "growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.column.due-date": [
    {
      "type": 0,
      "value": "Due date"
    }
  ],
  "growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.column.status": [
    {
      "type": 0,
      "value": "Status"
    }
  ],
  "growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.column.summary": [
    {
      "type": 0,
      "value": "Summary"
    }
  ],
  "growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.created-by": [
    {
      "type": 0,
      "value": "Created by "
    },
    {
      "type": 1,
      "value": "projectAdmin"
    }
  ],
  "growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.header-admin-only": [
    {
      "type": 1,
      "value": "projectAdmin"
    },
    {
      "type": 0,
      "value": " is waiting for you to join '"
    },
    {
      "type": 1,
      "value": "projectName"
    },
    {
      "type": 0,
      "value": "'"
    }
  ],
  "growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.header-many-user": [
    {
      "type": 1,
      "value": "projectAdmin"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " other"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " others"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "otherUsers"
    },
    {
      "type": 0,
      "value": " are waiting for you to join '"
    },
    {
      "type": 1,
      "value": "projectName"
    },
    {
      "type": 0,
      "value": "'"
    }
  ],
  "growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.in-body-header": [
    {
      "type": 0,
      "value": "Your team is waiting for you to join them in Jira"
    }
  ],
  "growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Reminder: You’ve been invited to plan and track work in Jira"
    }
  ],
  "growth-jira-onboarding.invite-reminder-with-board-activity.message-template.status.category.done": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "growth-jira-onboarding.invite-reminder-with-board-activity.message-template.status.category.inProgress": [
    {
      "type": 0,
      "value": "In Progress"
    }
  ],
  "growth-jira-onboarding.invite-reminder-with-board-activity.message-template.status.category.todo": [
    {
      "type": 0,
      "value": "To Do"
    }
  ],
  "growth-jira-onboarding.invite-reminder-with-board-activity.social-proof.text": [
    {
      "children": [
        {
          "type": 0,
          "value": "Jira is the #1 project management tool"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " where over 75,000+ customers plan and track work across every team."
    }
  ],
  "growth-jira-onboarding.invite-reminder-with-board-activitye.message-template.email.project-launch": [
    {
      "type": 1,
      "value": "projectName"
    }
  ],
  "growth-jira-onboarding.jira-onboarding-forward-invite.message-template.email.body-text": [
    {
      "children": [
        {
          "type": 0,
          "value": "Jira is the #1 project management tool"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " where over 75,000+ customers plan and track work across every team."
    }
  ],
  "growth-jira-onboarding.jira-onboarding-forward-invite.message-template.email.button-text": [
    {
      "type": 0,
      "value": "Join now"
    }
  ],
  "growth-jira-onboarding.jira-onboarding-forward-invite.message-template.email.created-by": [
    {
      "type": 0,
      "value": "Created by "
    },
    {
      "type": 1,
      "value": "projectAdmin"
    }
  ],
  "growth-jira-onboarding.jira-onboarding-forward-invite.message-template.email.header": [
    {
      "type": 0,
      "value": "Start collaborating with your team in Jira"
    }
  ],
  "growth-jira-onboarding.jira-onboarding-forward-invite.message-template.email.invite-nudge.banner": [
    {
      "type": 0,
      "value": "👋 "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Forward this email"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " to easily invite more teammates"
    }
  ],
  "growth-jira-onboarding.jira-onboarding-forward-invite.message-template.email.project-launch": [
    {
      "type": 1,
      "value": "filteredProjectName"
    },
    {
      "type": 0,
      "value": " Launch"
    }
  ],
  "growth-jira-onboarding.jira-onboarding-forward-invite.message-template.email.subject.start-collaborating": [
    {
      "type": 0,
      "value": "Start collaborating with your team on "
    },
    {
      "type": 1,
      "value": "filteredProjectName"
    }
  ],
  "growth-jira-onboarding.jira-onboarding-forward-invite.message-template.email.unsubscribe-link-text": [
    {
      "children": [
        {
          "type": 0,
          "value": "Unsubscribe"
        }
      ],
      "type": 8,
      "value": "a"
    },
    {
      "type": 0,
      "value": " to opt out of future emails like this"
    }
  ],
  "jira-sidebar-nav-day-x-notification.body-text": [
    {
      "type": 0,
      "value": "We’ve added features to boost your productivity. "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Customize your sidebar"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " to change what shows up."
    }
  ],
  "jira-sidebar-nav-day-x-notification.button-text": [
    {
      "type": 0,
      "value": "Got it"
    }
  ],
  "post-office.components.email.default-project-name": [
    {
      "type": 0,
      "value": "Big Campaign"
    }
  ],
  "post-office.components.email.footer.copyright": [
    {
      "type": 0,
      "value": "Copyright "
    },
    {
      "type": 1,
      "value": "year"
    },
    {
      "type": 0,
      "value": " Atlassian Pty Ltd. All rights reserved."
    }
  ],
  "post-office.components.email.footer.office-address": [
    {
      "type": 0,
      "value": "341 George Street, Sydney, NSW, 2000, Australia"
    }
  ],
  "post-office.growth-jira-onboarding-common.footer.atlassian-logo-alt": [
    {
      "type": 0,
      "value": "Atlassian"
    }
  ],
  "post-office.growth-jira-onboarding-common.footer.contact-us": [
    {
      "type": 0,
      "value": " Contact us • "
    }
  ],
  "post-office.growth-jira-onboarding-common.footer.copyright": [
    {
      "type": 0,
      "value": "Copyright "
    },
    {
      "type": 1,
      "value": "year"
    },
    {
      "type": 0,
      "value": " Atlassian Pty Ltd. All rights reserved. "
    }
  ],
  "post-office.growth-jira-onboarding-common.footer.facebook-alt-text": [
    {
      "type": 0,
      "value": "Facebook"
    }
  ],
  "post-office.growth-jira-onboarding-common.footer.facebook-title": [
    {
      "type": 0,
      "value": "Facebook"
    }
  ],
  "post-office.growth-jira-onboarding-common.footer.footer-links.contact-us": [
    {
      "type": 1,
      "value": "contactLink"
    }
  ],
  "post-office.growth-jira-onboarding-common.footer.footer-links.join-atlassian-community": [
    {
      "type": 1,
      "value": "joinAtlassianCommunity"
    }
  ],
  "post-office.growth-jira-onboarding-common.footer.footer-links.privacy-policy": [
    {
      "type": 1,
      "value": "privacyPolicy"
    }
  ],
  "post-office.growth-jira-onboarding-common.footer.footer-links.read-in-browser": [
    {
      "type": 1,
      "value": "readInBrowser"
    }
  ],
  "post-office.growth-jira-onboarding-common.footer.footer-links.read-our-blog": [
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "thirdText"
    }
  ],
  "post-office.growth-jira-onboarding-common.footer.join-atlassian-community": [
    {
      "type": 0,
      "value": "Join Atlassian Community"
    }
  ],
  "post-office.growth-jira-onboarding-common.footer.linkedin-alt-text": [
    {
      "type": 0,
      "value": "LinkedIn"
    }
  ],
  "post-office.growth-jira-onboarding-common.footer.linkedin-title": [
    {
      "type": 0,
      "value": "LinkedIn"
    }
  ],
  "post-office.growth-jira-onboarding-common.footer.office-address": [
    {
      "type": 0,
      "value": "We are located at 341 George Street, Sydney, NSW, 2000, Australia"
    }
  ],
  "post-office.growth-jira-onboarding-common.footer.partner-portal": [
    {
      "type": 0,
      "value": "Partner Portal"
    }
  ],
  "post-office.growth-jira-onboarding-common.footer.privacy-policy": [
    {
      "type": 0,
      "value": "Privacy Policy • "
    }
  ],
  "post-office.growth-jira-onboarding-common.footer.read-in-browser": [
    {
      "type": 0,
      "value": "Read in browser • "
    }
  ],
  "post-office.growth-jira-onboarding-common.footer.read-our-blog": [
    {
      "type": 0,
      "value": "Read our blog • "
    }
  ],
  "post-office.growth-jira-onboarding-common.footer.twitter-alt-text": [
    {
      "type": 0,
      "value": "Twitter"
    }
  ],
  "post-office.growth-jira-onboarding-common.footer.twitter-title": [
    {
      "type": 0,
      "value": "Twitter"
    }
  ],
  "post-office.growth-jira-onboarding-common.footer.unsubscribe": [
    {
      "type": 0,
      "value": "If you no longer wish to receive these emails, please update your preferences or "
    },
    {
      "type": 1,
      "value": "unsubscribe"
    },
    {
      "type": 0,
      "value": " here."
    }
  ],
  "post-office.growth-jira-onboarding-common.footer.unsubscribeText": [
    {
      "type": 0,
      "value": "unsubscribe"
    }
  ],
  "post-office.growth-jira-onboarding-common.jira-email-header.atlassian-text": [
    {
      "type": 0,
      "value": "Atlassian"
    }
  ],
  "post-office.growth-jira-onboarding-common.jira-email-header.jira-logo-alt-text": [
    {
      "type": 0,
      "value": "Jira"
    }
  ],
  "post-office.growth-jira-onboarding-common.jira-email-header.jira-text": [
    {
      "type": 0,
      "value": "Jira"
    }
  ],
  "post-office.growth-jira-onboarding.jira-messaging-research-recruitment.screen-space-flags.description": [
    {
      "type": 0,
      "value": "Tell us about your setup experience and we’ll send you a $100 gift card as a thank you."
    }
  ],
  "post-office.growth-jira-onboarding.jira-messaging-research-recruitment.screen-space-flags.header": [
    {
      "type": 0,
      "value": "Join our paid research study 💸"
    }
  ],
  "post-office.growth-jira-onboarding.jira-rovo-spotlight.screen-space-flags.body": [
    {
      "type": 0,
      "value": "Get started with smart suggestions, or ask Rovo anything."
    }
  ],
  "post-office.growth-jira-onboarding.jira-rovo-spotlight.screen-space-flags.cta": [
    {
      "type": 0,
      "value": "View suggestions"
    }
  ],
  "post-office.growth-jira-onboarding.jira-rovo-spotlight.screen-space-flags.headline": [
    {
      "type": 0,
      "value": "Welcome to Jira!"
    }
  ],
  "post-office.growth-jira-onboarding.jira-setup-user-interviews-signup.screen-space-flags.cta-link": [
    {
      "type": 0,
      "value": "Join now"
    }
  ],
  "post-office.test-placement.jonboarding-jira-side-nav-projects.dismiss-button.no-translate": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ]
}